// AddnewSO
import React, { useState, useEffect } from "react";
import {
  RightLayoutContainer,
  PageTitleComp,
  DetailFields,
  GroupTitle,
  DownArrowDraw,
  DropDownSearchDraw,
} from "../../styledElements";
import "antd/dist/antd.css";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Select,
  PageHeader,
  DatePicker,
  Upload,
} from "antd";
import { HaberForm } from "../../styledElements";
import { DatePickerY, GlobalSet } from "../../pageStyled";
import moment from "moment";
import warning from "../../../Assets/Icons/warning.png";
import { ModalPopup } from "../../../Components/Modal/modal";
import { useNavigate, useLocation } from "react-router-dom";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import MultiDiaAddOrderDrawer from "../OrderDetailDrawer/multiDiaAddOrderDrawer";
import { newUploadOrders, uploadPODocuments } from "../../../Services/uploadServices";
import { getSoDetails, updateSo } from "../../../Services/orderServices";
import { getImageURL } from "../../../Services/deckleMatchServices";

const { Dragger } = Upload;

const AddNewSoData = (props) => {
  const history = useNavigate();
  const [isEditMode, setIsEditMode] = useState(false);
  const [isView, setIsView] = useState(props.isView);
  const [isCancelModalVisible, setIsCancelModalVisible] = useState(false);
  const [soDate, setSoDate] = useState(moment().format("YYYY-MM-DD"));
  const [form] = Form.useForm();
  const [soNumber, setSoNumber] = useState("");
  const [refNumber, setRefNumber] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const [isToasterVisible, setIsToasterVisible] = useState(false);
  const [toasterMessage, setToasterMessage] = useState({ error: "", msg: "" });
  const [isNewOrderDrawerVisible, setIsNewOrderDrawerVisible] = useState(false);

  // Raw files to send later (newly uploaded in edit mode or creation)
  const [uploadedFiles, setUploadedFiles] = useState([]);
  // Keep track of size/type errors
  const [fileUploadErrors, setFileUploadErrors] = useState([]);
  // Pre-existing documents from server
  const [viewUploadedFiles, setViewUploadedFiles] = useState([]);
  const [isADD, setIsADD] = useState("");
  const [isEditAllowed, setIsEditAllowed] = useState(false);

  // Dragger: these are the files that will appear in the upload list (including already-uploaded + new)
  const [fileList, setFileList] = useState([]);

  // ----------------------------------
  // FETCH SO DETAILS
  // ----------------------------------
  
 const handleSoDetails = async (soNumber) => {
  try {
    const response = await getSoDetails(soNumber);

    // set form values
    form.setFieldsValue({
      date: response.data.date
        ? moment(response.data.date, "YYYY-MM-DD")
        : moment(),
      soNumber: soNumber,
      refNumber: response.data.reference_number,
    });

    setSoDate(
      response.data.date
        ? moment(response.data.date, "YYYY-MM-DD")
        : moment()
    );
    setRefNumber(response.data.reference_number);

    // fetch document URLs
   if (response?.data?.other_documents_location?.length) {
  const files = await Promise.all(
    response.data.other_documents_location.map(async (filePath) => {
      const fileName = filePath.split("/").pop();
      const url = await getImageURL({
        bucket_key: `${soNumber}/${fileName}`,
        operation: "download",
      });
      return { name: fileName, url };
    })
  );
  setViewUploadedFiles(files);
}
    setIsEditAllowed(response?.data?.so_editable);
  } catch (error) {
    console.log("Error in fetching SO details", error);
  }
};


  // ----------------------------------
  // EFFECT: Populate Dragger’s file list
  // ----------------------------------
  // useEffect(() => {
  //   // If we are editing, convert viewUploadedFiles into Dragger’s file list
  //   if (isEditMode && viewUploadedFiles?.length) {
  //     const convertedFileList = viewUploadedFiles.map((filePath, idx) => {
  //       // filePath might be just "file.pdf" or "SO-12345/file.pdf", 
  //       // depending on how your backend returns it
  //       const fileName = filePath.split("/").pop();
  //       // IMPORTANT: match the link used in view-mode (which is soNumber + "/" + fileName)
  //       return {
  //         uid: String(idx),
  //         name: fileName,
  //         status: "done",
  //       };
  //     });
  //     setFileList(convertedFileList);
  //   } else if (!isEditMode) {
  //     // Clear if we exit edit mode
  //     setFileList([]);
  //   }
  // }, [isEditMode, viewUploadedFiles, soNumber]);

   useEffect(() => {
  const prepareFileList = async () => {
    if (isEditMode && viewUploadedFiles?.length) {
      const convertedFileList = await Promise.all(
        viewUploadedFiles.map(async (filePath, idx) => {
          const fileName = filePath.name.split("/").pop();
          const url = await getImageURL({
            bucket_key: `${soNumber}/${fileName}`, // fixed template literal
            operation: "download",
          });

          return {
            uid: String(idx),
            name: fileName,
            status: "done",
            url,
          };
        })
      );

      setFileList(convertedFileList);
    } else if (!isEditMode) {
      setFileList([]);
    }
  };

  prepareFileList();
}, [isEditMode, viewUploadedFiles, soNumber]);

  // ----------------------------------
  // DRAGGER CONFIG
  // ----------------------------------
  const fileUploadProps = {
    name: "file",
    multiple: false,
    maxCount: 5,
    listType: "picture",
    accept: "image/jpg, image/jpeg, .pdf",
    fileList, // This is the local state array

    beforeUpload: () => false, // prevents immediate upload

    onChange(info) {
      // Updated file list in Dragger’s UI
      setFileList([...info.fileList]);

      // Check newly added file for errors
      const latestFile = info.fileList.slice(-1)[0];
      if (latestFile) {
        const fileSizeMB = latestFile.size / 1024 / 1024;
        const validType = [
          "application/pdf",
          "image/jpeg",
          "image/jpg",
        ].includes(latestFile.type);

        if (fileSizeMB > 1 || !validType) {
          setFileUploadErrors((prevErrors) => [
            ...prevErrors,
            {
              key: latestFile.uid,
              err: true,
              name: latestFile.name,
            },
          ]);
        } else {
          setFileUploadErrors([]);
        }
      }

      // Keep raw references (new files) for uploading later
      const allRawFiles = info.fileList
        .filter((f) => f.originFileObj) // newly added
        .map((f) => f.originFileObj);

      setUploadedFiles(allRawFiles);
    },

    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },

    onPreview(file) {
      // Attempt to open the file in a new tab
      window.open(file.url || file.thumbUrl, "_blank");
    },
  };

  // ----------------------------------
  // GENERIC NAVS / HELPERS
  // ----------------------------------
  const goBack = () => navigate("../order-records");

  const handleBack = () => {
    navigate(location.state.backKey, {
      state: {
        soNumber: soNumber,
        isSo: true,
      },
    });
  };

  const showCancelModal = () => setIsCancelModalVisible(true);
  const closeCancelModal = () => setIsCancelModalVisible(false);

  const confirmCancelModal = () => {
    if (isEditMode) {
      setIsEditMode(false);
      setIsView(true);
      closeCancelModal();
    } else {
      goBack();
      closeCancelModal();
      form.resetFields();
    }
  };

  const showToaster = (msg, isError = false) => {
    setToasterMessage({ isError, msg });
    setIsToasterVisible(true);
    setTimeout(() => setIsToasterVisible(false), 3000);
  };

  // ----------------------------------
  // DATE HANDLING
  // ----------------------------------
  const handleDateChange = (date) =>
    setSoDate(moment(date).format("YYYY-MM-DD"));

  // ----------------------------------
  // SUBMIT & ADD ORDERS
  // ----------------------------------
  const handleAddNewOrder = () => {
    // If we’re in view mode, this shows the “orders” for the existing SO
    // Or if we’re in creation mode, it triggers form.submit
    form.submit();
  };

  const onFinish = async (values) => {
    // If needed, validate or handle reference number
    // Collect names of newly added files
    let uploadedDocsArr = [];
    uploadedFiles.forEach((file) => {
      uploadedDocsArr.push(file.name);
    });

    const formattedValues = {
      ...values,
      date: moment(values.date).format("YYYY-MM-DD"),
      reference_number: refNumber,
      uploadedDocsArr,
    };

    history("../order-details", {
      state: {
        values: formattedValues,
        route: "add-new-so",
        isSo: true,
        soNumber: soNumber,
        backKey: location.state.backKey,
        uploadDocument: uploadedFiles, // pass the actual files
        dummyOrders: location?.state?.dummyOrders
      },
    });
  };

  // ----------------------------------
  // EDIT FLOW
  // ----------------------------------
  const handleEdit = () => {
    setIsView(false);
    setIsEditMode(true);
  };

  const handleUpdateSo = async () => {
    let newFile = [];

    // 1) Upload newly added files
    for (let i = 0; i < uploadedFiles.length; i++) {
      newFile.push(uploadedFiles[i]["name"]);
      try {
        // const response = await uploadPODocuments(soNumber, uploadedFiles[i]);
        // Step 1: Generate signed URL for upload
        const res = await getImageURL({
          bucket_key: `${soNumber}/${uploadedFiles[i]["name"]}`,
          operation: "upload",
        });

        // Step 2: Upload file to that signed URL
        const uploadResponse = await newUploadOrders(res, uploadedFiles[i]);
        console.log("Uploaded successfully:", uploadResponse);
      } catch (err) {
        console.log(err);
      }
    }

    // 2) Keep the previously existing files (assuming user doesn’t remove them)
    viewUploadedFiles.forEach((fileName) => {
      newFile.push(fileName.name.split("/").pop());
    });

    // Prepare request body to update the SO
    const body = {
      ...(newFile && { other_documents_location: newFile }),
      ...(refNumber && { reference_number: refNumber }),
      number: soNumber,
      date: moment(soDate).format("YYYY-MM-DD"),
    };

    await updateSo(soNumber, body)
      .then((response) => {
        setToasterMessage({
          error: response.error,
          msg: `So updated successfully`,
        });
        setIsToasterVisible(true);
        setTimeout(() => {
          setIsToasterVisible(false);
        }, 3000);
        handleSoDetails(soNumber);
        setIsView(true);
        setIsEditMode(false);
      })
      .catch((error) => {
        console.log("Error in updating so:", error);
        setToasterMessage({
          error: error,
          msg: `So cannot be updated successfully`,
        });
        setIsToasterVisible(true);
        setTimeout(() => {
          setIsToasterVisible(false);
        }, 1000);
      });
  };

  // ----------------------------------
  // LIFECYCLE EFFECTS
  // ----------------------------------
  useEffect(() => {
    // isADD indicates a new SO creation flow
    setIsADD(location.state.isADD);
  }, [location.state.isADD]);

  useEffect(() => {
    // If we came from order-details with partial data
    if (location?.state?.isData) {
      form.setFieldsValue({
        date: location?.state?.values?.date
          ? moment(location?.state?.values?.date, "YYYY-MM-DD")
          : moment(),
      });
      setSoDate(
        location?.state?.values?.date
          ? moment(location?.state?.values?.date, "YYYY-MM-DD")
          : moment()
      );
      form.setFieldsValue({
        refNumber: location?.state?.values?.refNumber,
      });
      setRefNumber(location?.state?.values?.refNumber);
      setIsADD(location.state.isADD);
    }
  }, [location.state, form]);

  useEffect(() => {
    // If we come in with an existing SO for view
    if (location?.state?.isView) {
      setIsView(location?.state?.isView);
      setSoNumber(location?.state?.soNumber);
    }
  }, [location.state]);

  useEffect(() => {
    // If we have an SO number, fetch details
    if (!soNumber) return;
    handleSoDetails(soNumber);
  }, [soNumber]);

  // ----------------------------------
  // JSX RETURN
  // ----------------------------------
  return (
    <RightLayoutContainer>
      <PageTitleComp
        className="marginRightAdg"
        style={{ marginBottom: "12px" }}
      >
        <PageHeader
          title={soNumber ? `SO Details - ${soNumber}` : "Add a new SO"}
          onBack={
            (isEditMode || isView) && soNumber ? () => handleBack() : false
          }
          extra={[
            isView ? (
              <Button
                key="3"
                className="themeBtn noBg"
                onClick={handleEdit}
                // disabled={!isEditAllowed} // if needed
              >
                <Iconmoon icon="edit" size={14} color="var(--theme-color)" />
                Edit
              </Button>
            ) : (
              <Button
                key="3"
                className="textTypeBtn"
                onClick={showCancelModal}
                disabled={location.state?.cancelChangesDisable}
                style={{ background: "transparent" }}
              >
                Cancel changes
              </Button>
            ),
            !isEditMode && (
              <Button
                key="1"
                className="themeBtn"
                onClick={handleAddNewOrder}
                disabled={fileUploadErrors.length}
              >
                <Iconmoon icon="file-check" size={14} color="#ffffff" />
                {isView ? "View Orders" : "Add Orders"}
              </Button>
            ),
            isEditMode && (
              <Button
                key="1"
                className="themeBtn"
                onClick={handleUpdateSo}
                disabled={fileUploadErrors.length}
              >
                <Iconmoon size={14} color="#ffffff" />
                Save
              </Button>
            ),
          ]}
        />
      </PageTitleComp>

      <DetailFields>
        <div className="groupDetailWrap">
          <Form
            id="form"
            form={form}
            name="basic"
            autoComplete="off"
            className="haberLogin"
            onFinish={onFinish}
          >
            <HaberForm>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>General Details</h2>
                    <p>
                      General details will be used to identify Stock Order in
                      reports
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  {(isEditMode || isView) && (
                    <Row className="centerAlign">
                      <Col span={12}>
                        <div className="boxFieldTitle">
                          <label>SO Number</label>
                          <p>A unique number to identify the Stock Order</p>
                        </div>
                      </Col>
                      <Col span={12}>
                        <div className="boxFormType">
                          <Form.Item
                            name="soNumber"
                            rules={[
                              {
                                required: true,
                                message: "SO number is required",
                              },
                              {
                                max: 50,
                                message:
                                  "SO number can have a maximum of 50 characters",
                              },
                            ]}
                          >
                            <Input
                              placeholder="Enter SO Number"
                              disabled={true}
                              value={soNumber}
                              style={{ textTransform: "uppercase" }}
                            />
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                  )}

                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>SO Date</label>
                        <p>Date when Stock Order was received</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <DatePickerY>
                          <Form.Item
                            name="date"
                            initialValue={moment(soDate, "YYYY-MM-DD")}
                          >
                            <DatePicker
                              format={"YYYY-MM-DD"}
                              onChange={handleDateChange}
                              value={moment(soDate, "YYYY-MM-DD")}
                              disabled={isEditMode || isView}
                            />
                          </Form.Item>
                        </DatePickerY>
                      </div>
                    </Col>
                  </Row>

                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          Reference Number
                          <label
                            style={{ fontStyle: "italic", color: "#605e5c" }}
                          >
                            (Optional)
                          </label>
                        </label>
                        <p>Reference number of the Stock Order</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="refNumber"
                          rules={[
                            {
                              required: false,
                            },
                            {
                              max: 50,
                              message:
                                "SO reference number can have a maximum of 50 characters",
                            },
                          ]}
                          initialValue={refNumber}
                        >
                          <Input
                            placeholder="Enter Reference Number"
                            disabled={isView}
                            value={refNumber}
                            onChange={(e) => setRefNumber(e.target.value)}
                            style={{ textTransform: "uppercase" }}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </HaberForm>

            <Row gutter={[16, 16]} className="groupForm lastGroup">
              <Col span={8}>
                <GroupTitle>
                  <h2>Other Information</h2>
                  <p>All other information related to this SO</p>
                </GroupTitle>
              </Col>
              <Col span={16}>
                <Row className="centerAlign">
                  <Col span={12}>
                    <div className="boxFieldTitle">
                      <label>Documents</label>
                      <p
                        style={{
                          fontSize: "14px",
                          lineHeight: "20px",
                          fontFamily: "var(--sf-pro-display-m)",
                          color: "var(--black-color)",
                          marginBottom: "5px",
                          width: "91%",
                        }}
                      >
                        Scanned copies, PDF and other documents related to the
                        SO
                      </p>
                    </div>
                  </Col>

                  {isADD || isEditMode ? (
                    // ------ EDIT/UPLOAD MODE ------
                    <Col span={12} className="blockBreak">
                      {/* Show file upload errors */}
                      {fileUploadErrors?.length
                        ? fileUploadErrors.map((item, index) =>
                            item.err ? (
                              <React.Fragment key={index}>
                                {index > 0 ? <br /> : null}
                                <span
                                  className="errorText"
                                  style={{
                                    color: "#ea4e2c",
                                    marginTop: "-17px",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Invalid file: {item.name}
                                </span>
                              </React.Fragment>
                            ) : null
                          )
                        : null}
                      {fileUploadErrors?.length ? (
                        <>
                          <br />
                          <span
                            className="errorText"
                            style={{
                              color: "#ea4e2c",
                              marginTop: "-17px",
                              marginBottom: "5px",
                            }}
                          >
                            Supported file formats: JPG, JPEG or PDF; Max size:
                            1 MB
                          </span>
                        </>
                      ) : null}

                      <div
                        className="boxFormType csv-file"
                        style={{ marginBottom: "0" }}
                      >
                        <Dragger
                          {...fileUploadProps}
                          style={{ border: "1px dashed #d9d9d9" }}
                        >
                          <p
                            className="ant-upload-drag-icon"
                            style={{ marginTop: "11px" }}
                          >
                            <Iconmoon
                              icon="upload-image"
                              size={18}
                              color="#A19F9D"
                            />
                          </p>
                          <p className="ant-upload-text">
                            <span>Click to add</span> or drag and drop
                          </p>
                          <p
                            className="ant-upload-hint"
                            style={{ marginBottom: "11px" }}
                          >
                            JPG, JPEG or PDF (max. 1 MB)
                          </p>
                        </Dragger>
                      </div>
                    </Col>
                  ) : (
                    // ------ VIEW-ONLY MODE ------
                    <Col span={12} className="blockBreak">
                      {viewUploadedFiles?.length
                        ? viewUploadedFiles.map((file, index) => (
                            <div className="boxFieldTitle" key={index}>
                              <a
                                href={file.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "#EA655B" }}
                              >
                                {file.name || "View Document"}
                              </a>
                            </div>
                          ))
                        : "No documents available"}
                    </Col>
                  )}
                </Row>
              </Col>
            </Row>
          </Form>
        </div>

        {/* Extra "Add orders" button */}
        <Row gutter={[16, 16]}>
          <Col span={8}></Col>
          <Col span={16}>
            <Row className="centerAlign">
              <Col span={12}></Col>
              <Col span={12} className="blockBreak">
                <Col
                  span={12}
                  className="d-flex"
                  style={{ marginLeft: "-23px" }}
                >
                  <div className="boxFormType"></div>
                  <div className="boxFormType">
                    <GlobalSet>
                      <Button
                        key="addOrder"
                        className="textTypeBtn textBtnIcon"
                        onClick={handleAddNewOrder}
                        disabled={fileUploadErrors.length}
                      >
                        <Iconmoon icon="addcircle" size={15} color="#EA655B" />
                        Add orders to this SO
                      </Button>
                    </GlobalSet>
                  </div>
                </Col>
              </Col>
            </Row>
          </Col>
        </Row>
      </DetailFields>

      {/* Cancel Changes Modal */}
      <ModalPopup visible={isCancelModalVisible}>
        <div className="Popup-img">
          <img src={warning} alt="Warning" />
        </div>
        <div className="Popup-content">
          <span>Are you sure?</span>
          <p>
            You have pending changes on this page, are you sure you want to
            leave?
          </p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => closeCancelModal()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>

          <Button
            key="submit"
            className="themeBtn"
            onClick={confirmCancelModal}
          >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup>

      {isToasterVisible && (
        <AlertContainer
          setClose={setIsToasterVisible}
          color={toasterMessage.error ? "red toaster" : "green toaster"}
          icon={toasterMessage.error ? alertRed : alertGreen}
          msg={toasterMessage.msg}
          closeIcon={false}
        />
      )}

      {/* Drawer for multi dia add order - if needed */}
      <MultiDiaAddOrderDrawer
        visible={isNewOrderDrawerVisible}
        onClose={() => setIsNewOrderDrawerVisible(false)}
      />
    </RightLayoutContainer>
  );
};

export default AddNewSoData;
